'use strict';

var React = require('react'),
    UserLink = require('../atoms/UserLink'),
    ServiceAccountStore = require('../stores/ServiceAccountStore'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    UserStore = require('../stores/UserStore'),
    FollowUserButton = require('../molecules/FollowUserButton'),
    UserInfo = require('../organisms/UserInfo'),
    pluralize = require('../utils/pluralize'),
    formatCount = require('../utils/formatCount'),
    PropTypes = React.PropTypes;

require('./UserItem.less');

var UserItem = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin, createStoreMixin(ServiceAccountStore, UserStore)],

  propTypes: {
    user: React.PropTypes.object.isRequired,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    imageSize: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge']),
    showAbout: PropTypes.bool,
    showLocation: PropTypes.bool,
    showWebsite: PropTypes.bool,
    showAccounts: PropTypes.bool,
    showSubscribers: PropTypes.bool,
    showSubscriptions: PropTypes.bool,
    showFollow: PropTypes.bool
  },

  getDefaultProps() {
    return {
      size: 'medium',
      showAbout: false,
      showLocation: false,
      showWebsite: false,
      showAccounts: false,
      showSubscribers: false,
      showSubscriptions: false,
      showFollow: false
    };
  },

  getStateFromStores(props) {
    return {
      isMe: UserStore.isMe(props.user.id)
    };
  },

  componentWillReceiveProps(nextProps) {
    if (this.props.user !== nextProps.user) {
      this.setState(this.getStateFromStores(nextProps));
    }
  },

  getCSSModifiers() {
    return [
      this.props.size
    ];
  },

  render() {
    var { user, showFollow } = this.props,
        { isMe } = this.state,
        subscriberCount = this.props.user.subscriberCount;

    return (
      <div className={this.getClassName()}>
        <div className='UserItem-body'>
          <UserLink user={user}
                    className='UserItem-link'>
            {' '}
          </UserLink>
          <UserInfo user={user}
                    size={this.props.size}
                    imageSize={this.props.imageSize}
                    showAbout={this.props.showAbout}
                    showLocation={this.props.showLocation}
                    showWebsite={this.props.showWebsite}
                    showAccounts={this.props.showAccounts}
                    showSubscribers={this.props.showSubscribers}
                    showSubscriptions={this.props.showSubscriptions}
                    context='UserItem'
                    vertical />
        </div>

        {showFollow && !isMe &&
          <div className='UserItem-footer'>
            <FollowUserButton user={user}
                              context='UserItem' />
          </div>
        }

        {isMe &&
          <div className='UserItem-footer'>
            <span>
              {formatCount(subscriberCount)}
              {' '}
              {pluralize(subscriberCount, 'Follower', 'Followers')}
            </span>
          </div>
        }
      </div>
    );
  }
});

module.exports = UserItem;



/** WEBPACK FOOTER **
 ** ./organisms/UserItem.jsx
 **/